import React, { Component } from 'react'
import Axios from 'axios'
import Swiper from 'react-id-swiper'
import Mtop from '../../common/lib/mtop'
import Login from '../../common/Header/Login'
import Utils from '../../lib/utils'
import styles from './index.module.less'
import './customized.css'

const fixZero = num => (num < 10 ? `0${num}` : `${num}`)

export default class Carousel extends Component {
  state = {
    title: '体育赛程',
    matchsList: []
  }
  constructor (props) {
    super(props)
    this.defaultSlide = 0
  }
  componentDidMount () {
    this.getTit()
    this.getList()
  }
  getTit () {
    Axios.get('//live-interact.youku.com/sports/marquee/all').then((response) => {
      if (response.data) {
        this.setState({
          title: response.data[0].content
        })
      }
    }).catch(e => {})
  }
  getList () {
    Mtop.request('mtop.youku.sports.show.schedule.drawer.list').then(res => {
      if (res.data.matchsList && res.data.matchsList.length > 0) {
        this.checkSub(res.data.matchsList)
      }
    }).catch(e => {})
  }
  sub (liveId) {
    Mtop.request('mtop.youku.live.infoapi.subscribe', {
      data: {
        liveId: liveId,
        source: 'pc-sports-schedule'
      },
      v: '2.0'
    }).then(res => {
      if (res.data.status === 200) {
        let data = this.state.matchsList
        for (let i = 0; i < data.length; i++) {
          if (data[i].liveId === liveId) {
            data[i].isSub = 1
            break
          }
        }
        this.setState({
          matchsList: data
        })
      } else if (res.data.status === 400) {
        Login.login()
      }
    }).catch(e => {})
  }
  checkSub (data) {
    let liveIds = []
    let posFound = false
    for (let i = 0; i < data.length; i++) {
      if (!posFound && (data[i].liveStatus === 1 || data[i].liveStatus === 0)) {
        this.defaultSlide = Math.ceil((i + 1) / 2) - 1
        posFound = true
      }
      liveIds.push(data[i].liveId)
    }
    Mtop.request('mtop.youku.live.infoapi.checksubscribe', {
      data: {
        liveIds: liveIds.toString()
      }
    }).then(res => {
      let subs = res.data.data
      for (let x = 0; x < data.length; x++) {
        for (let y = 0; y < subs.length; y++) {
          if (data[x].liveId === subs[y].liveId) {
            data[x].isSub = subs[y].isSub
          }
        }
      }
      this.setState({
        matchsList: data
      }, () => {
        if (this.defaultSlide > 0) {
          this.swiper.slideTo(this.defaultSlide)
        }
      })
    }).catch(e => {})
  }
  vsRender (item, index, formatTime, spmABCD) {
    let { homeTeamGoal, guestTeamGoal } = item.matchInfo
    if (homeTeamGoal === null || homeTeamGoal === undefined || homeTeamGoal === '') {
      homeTeamGoal = '-　'
    }
    if (guestTeamGoal === null || guestTeamGoal === undefined || guestTeamGoal === '') {
      guestTeamGoal = '　-'
    }
    if (item.liveStatus === 0) {
      homeTeamGoal = '-　'
      guestTeamGoal = '　-'
    }
    let goalColor = item.liveStatus === 1 ? '#F95145' : '#000000'
    return (
      <div className={styles.card} key={index} onClick={this.itemClick.bind(this, item, spmABCD)}>
        <div className={styles.card_wrapper}>
          <div className={styles.card_tit}>
            <div className={styles.league_name}>{item.matchInfo.matchTitle}</div>
            <div className={styles.live_type}>
              {(item.liveStatus === 0 && item.playType === 1) && <span className={styles.live_video} />}
              {(item.liveStatus === 0 && item.playType === 2) && <span className={styles.live_text} />}
              <span className={styles.live_time}>
                {(item.liveStatus === 0 && item.playType === 1) && ' 视频直播 '}
                {(item.liveStatus === 0 && item.playType === 2) && ' 图文直播 '}
                {formatTime}
                {item.liveStatus === 2 && ' 已结束'}
              </span>
            </div>
          </div>
          <div className={styles.card_con}>
            <div className={styles.card_team}>
              <div className={styles.team_logo}>
                <img width='30' height='30' src={item.matchInfo.homeTeamBadge} />
              </div>
              <div className={styles.team_name}>{item.matchInfo.homeTeamName}</div>
            </div>
            <div className={styles.team_score} style={{ paddingLeft: '5px', paddingRight: '5px', textAlign: 'right', color: goalColor }}>{homeTeamGoal}</div>
            <div className={styles.live_state}>
              {item.liveStatus === 0 && (item.isSub === 1 ? <div className={styles.live_state_2} /> : <div className={styles.live_state_1} onClick={(e) => this.subClick(e, item, spmABCD)} />)}
              {(item.liveStatus === 1 && item.playType === 1) && <div className={styles.live_state_3} />}
              {(item.liveStatus === 1 && item.playType === 2) && <div className={styles.live_state_4} />}
              {item.liveStatus === 2 && (item.showCode ? <div className={styles.live_state_5} /> : <div className={styles.live_state_6} />)}
            </div>
            <div className={styles.team_score} style={{ paddingLeft: '5px', paddingRight: '5px', textAlign: 'left', color: goalColor }}>{guestTeamGoal}</div>
            <div className={styles.card_team}>
              <div className={styles.team_logo}>
                <img width='30' height='30' src={item.matchInfo.guestTeamBadge} />
              </div>
              <div className={styles.team_name}>{item.matchInfo.guestTeamName}</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  otherRender (item, index, formatTime, spmABCD) {
    return (
      <div className={styles.card} key={index} onClick={this.itemClick.bind(this, item, spmABCD)}>
        <div className={styles.card_wrapper}>
          <div className={styles.card_tit}>
            <div className={styles.league_name} />
            <div className={styles.live_type}>
              {(item.liveStatus === 0 && item.playType === 1) && <span className={styles.live_video} />}
              {(item.liveStatus === 0 && item.playType === 2) && <span className={styles.live_text} />}
              <span className={styles.live_time}>
                {(item.liveStatus === 0 && item.playType === 1) && ' 视频直播 '}
                {(item.liveStatus === 0 && item.playType === 2) && ' 图文直播 '}
                {formatTime}
                {item.liveStatus === 2 && ' 已结束'}
              </span>
            </div>
          </div>
          <div className={styles.card_other}>
            <div className={styles.match_name}>{item.name}</div>
            <div className={styles.live_state}>
              {item.liveStatus === 0 && (item.isSub === 1 ? <div className={styles.live_state_2} /> : <div className={styles.live_state_1} onClick={(e) => this.subClick(e, item, spmABCD)} />)}
              {(item.liveStatus === 1 && item.playType === 1) && <div className={styles.live_state_3} />}
              {(item.liveStatus === 1 && item.playType === 2) && <div className={styles.live_state_4} />}
              {item.liveStatus === 2 && (item.showCode ? <div className={styles.live_state_5} /> : <div className={styles.live_state_6} />)}
            </div>
          </div>
        </div>
      </div>
    )
  }
  itemClick (item, spmABCD) {
    if (item.liveStatus === 2) {
      if (item.showCode) {
        if (item.leagueId === 19) {
          return false
        }
        window.location.href = `https://v.youku.com/v_nextstage/id_${item.showCode}?spm=${spmABCD}`
      }
    } else {
      window.location.href = `${item.liveUrl}&spm=${spmABCD}`
    }
  }
  subClick (e, item, spmABCD) {
    e.stopPropagation()
    const spm = `spm=${spmABCD}`
    const q = (window.goldlog_queue || (window.goldlog_queue = []))
    q.push({
      action: 'goldlog.record',
      arguments: ['/yt/click.index.module', 'CLK', spm, 'POST']
    })
    if (item.isSub !== 1) {
      this.sub(item.liveId)
    }
  }
  render () {
    const params = {
      spaceBetween: 10,
      slidesPerColumn: 2,
      // slidesPerGroup: 2,
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.customized-swiper-button-next',
        prevEl: '.customized-swiper-button-prev'
      },
      renderPrevButton: () => <div className='customized-swiper-button-prev' />,
      renderNextButton: () => <div className='customized-swiper-button-next' />
    }
    const { title, matchsList } = this.state
    const { spm } = this.props.data
    const ab = `${Utils.getSpmAB().spmA}.${Utils.getSpmAB().spmB}`
    return (
      <div className={styles.module_carousel} data-spm={spm} data-name={'c_pos'}>
        {title &&
          <div className={styles.module_header}>
            <h2 className={styles.module_title}>
              <span className={styles.main_title}>{title}</span>
            </h2>
          </div>
        }
        <div className={styles.module_con}>
          {matchsList.length > 1 && (
            <Swiper
              {...params}
              ref={node => {
                if (node) this.swiper = node.swiper
              }}
            >
              {matchsList.map((item, index) => {
                const timestamp = item.type === 0 ? item.matchInfo.startTime : item.startTime
                const liveTime = new Date(timestamp)
                const formatTime = `${fixZero(liveTime.getMonth() + 1)}/${fixZero(liveTime.getDate())} ${fixZero(liveTime.getHours())}:${fixZero(liveTime.getMinutes())}`
                const spmABCD = `${ab}.${spm}.card_${index}`
                if (item.type === 0) {
                  return this.vsRender(item, index, formatTime, spmABCD)
                } else {
                  return this.otherRender(item, index, formatTime, spmABCD)
                }
              })}
            </Swiper>
          )}
        </div>
      </div>
    )
  }
}
